export const CHART9_REQUEST = "CHART9_REQUEST";
export const CHART9_SUCCESS = "CHART9_SUCCESS";
export const CHART9_FAILURE = "CHART9_FAILURE";
